import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import {
  getCustomCashbackIconUrl,
  getActivateCashbackForPartner,
  getCashbackLabel,
  getCashbackTooltip,
  getIsMobile,
} from 'src/store/view/selectors';
import {
  getOffersForCurrentDateWithAllHotelFilters,
  getSearcherTouristsCount,
  getIsSetDefaultFilters,
} from '../../store/selectors/searcher';
import { openOfferAction } from '../../store/actions/offer';
import { getHotelFacilitiesRoomForSearcher } from '../../store/selectors/hotel';
import { openFiltersListAction } from '../../store/actions/searcher';

import { HotelRatesResults } from './HotelRatesResults';
import { openAboutRoomPopup } from '../../../../store/roomPopup/slice';
import { getSearchedNights } from '../../store/selectors/common';

const mapStateToProps = (state) => ({
  items: getOffersForCurrentDateWithAllHotelFilters(state),
  customCashbackIconURL: getCustomCashbackIconUrl(state),
  customCashbackText: getCashbackLabel(state),
  customCashbackTooltipText: getCashbackTooltip(state),
  activateCashbackForPartner: getActivateCashbackForPartner(state),
  searchedNights: getSearchedNights(state),
  hotelFacilities: getHotelFacilitiesRoomForSearcher(state),
  tourists: getSearcherTouristsCount(state),
  isSetDefaultFilters: getIsSetDefaultFilters(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = (dispatch) => ({
  onOfferClicked: (offer) => dispatch(openOfferAction(offer)),
  onClickOpenFilters: () => dispatch(openFiltersListAction(true)),
  onLeaveNotFullOffersSpan: () => dispatch(openFiltersListAction(false)),
  onClickGallery: (id) => dispatch(openAboutRoomPopup(id)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(HotelRatesResults);
